import { Decimal } from 'decimal.js';

/**
 * Calculate the low traffic threshold for a given objective and error tolerance
 * @param objective (0, 100) e.g 99.99
 * @param errorTolerance
 * @returns low traffic threshold
 */
export const getLowTrafficThreshold = (objective: number, errorTolerance: number): number => {
  if (!(objective < 100 && objective > 0 && errorTolerance > 0)) return 0;
  return Math.floor((100 * errorTolerance) / new Decimal(100).minus(objective).toNumber());
};
